import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);   // null = unknown/checking
  const [checked, setChecked] = useState(false);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (err) {
      // 401 on first visit is expected (anonymous user). Only log unexpected errors.
      if (err?.response?.status && err.response.status !== 401) {
        console.error("[AuthContext] refreshUser failed:", err);
      }
      setUser(false);
    } finally {
      setChecked(true);
    }
  }, []);

  useEffect(() => { refreshUser(); }, [refreshUser]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const register = async (name, email, password, profession) => {
    const { data } = await api.post("/auth/register", { name, email, password, profession });
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); }
    catch (err) { console.warn("[AuthContext] logout API call failed (clearing local state anyway):", err); }
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, checked, login, register, logout, refreshUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
